<template>
  <VPopupWidget
    :name="computedTitle"
    :icon="$vuetify.icons.values.add"
    :visible="menu"
    :set-expand="
      (v) => {
        menu = v
      }
    "
    btnDepressed
    btnColor="default"
    bottom
    left
  >
    <template slot="title">{{ $t('title') }}</template>

    <template slot="content">
      <FormErrors :show="showResourceErrors" :errors="resourceErrors" />
      <v-form>
        <v-text-field
          v-model.trim="form.display"
          :error-messages="displayErrors"
          v-bind:label="$t('displayName')"
          required
          @input="$v.form.display.$touch()"
          @blur="$v.form.display.$touch()"
          v-on:keyup.enter="submit"
        ></v-text-field>
      </v-form>
    </template>
    <template slot="footer-actions">
      <v-btn depressed @click="submit">{{ $t('add') }}</v-btn>
    </template>
  </VPopupWidget>
</template>

<script>
import { mapActions } from 'vuex'
import { NAMESPACE } from '../store'
import { required } from 'vuelidate/lib/validators'
import { BaseForm, FormErrors, VPopupWidget } from '@argon/app/components'

export default {
  extends: BaseForm,
  components: { FormErrors, VPopupWidget },
  props: {
    isIconBtn: { type: Boolean, default: false }
  },
  validations: {
    form: {
      display: { required }
    }
  },
  data: () => ({
    form: {
      display: ''
    },
    menu: false,
    loading: false
  }),
  computed: {
    displayErrors() {
      const errors = []
      if (!this.$v.form.display.$dirty) return errors
      !this.$v.form.display.required && errors.push(this.$t('newGroup.required'))
      this.getServerErrors('display', errors)
      return errors
    },
    computedTitle() {
      if (!this.isIconBtn) {
        return this.$t('title')
      } else {
        return null
      }
    }
  },
  methods: {
    ...mapActions(NAMESPACE, ['createGroup']),
    submit() {
      this.resetServerErrors()
      if (this.$v.form.$invalid) {
        return this.$v.form.$touch()
      }
      this.loading = true
      const payload = {
        display: this.form.display
      }
      this.createGroup(payload)
        .then(() => {
          this.menu = false
          this.$v.$reset()
        })
        .catch(this.setServerErrors)
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<i18n>
{
  "en": {
    "add": "@:labels.add",
    "displayName": "@:labels.displayName",
    "required": "@:labels.required",
    "title": "Add Group"
  },
  "fr": {
    "add": "@:labels.add",
    "displayName": "@:labels.displayName",
    "required": "@:labels.required",
    "title": "Ajouter un groupe"
  }
}
</i18n>
